import { render, staticRenderFns } from "./Kumpor.vue?vue&type=template&id=f8736f00&scoped=true&"
import script from "./Kumpor.vue?vue&type=script&lang=js&"
export * from "./Kumpor.vue?vue&type=script&lang=js&"
import style0 from "./Kumpor.vue?vue&type=style&index=0&id=f8736f00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8736f00",
  null
  
)

export default component.exports